import { isBar } from '../lib/places';
import type { PlaceSummary } from '../lib/types';

/** Bar pin color by backroad score; hand-picked bars are always amber (#F2A93B). */
export function scoreColor(score: number): string {
  if (score >= 80) return '#FFC76B';
  if (score >= 65) return '#E8D9A8';
  if (score >= 50) return '#B4AF9E';
  return '#6E7470';
}

/** Bites run warm red, brightest for the highest scores; hand-picked bites are #FF7A59. */
export function biteColor(score: number): string {
  if (score >= 80) return '#FF8F6B';
  if (score >= 65) return '#F2A48C';
  if (score >= 50) return '#C98F7E';
  return '#8A6A60';
}

export const BITE = '#FF7A59';
const AMBER = '#F2A93B';

/** A place's pin color: amber or bite-red for hand-picked places, otherwise by backroad score. */
export function pinColor(p: Pick<PlaceSummary, 'kind' | 'isCurated' | 'backroadScore'>): string {
  if (isBar(p.kind)) return p.isCurated ? AMBER : scoreColor(p.backroadScore);
  return p.isCurated ? BITE : biteColor(p.backroadScore);
}
